import { Box, Stack, Tooltip, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import TableBodyCell from '../TableBodyCell'
import { getBoxStyles, getTypographyStyles } from './style'

interface PaymentCellProps {
  tooltipName: string
  src: string | null
  backgroundColor?: string
}

const PaymentCell: FC<PaymentCellProps> = ({
  tooltipName,
  src,
  backgroundColor,
}) => {
  return (
    <TableBodyCell backgroundColor={backgroundColor}>
      <Box sx={getBoxStyles()}>
        {src && (
          <Tooltip title={tooltipName} placement='top'>
            <Stack
              direction={'row'}
              spacing={'16px'}
              alignItems={'center'}
              maxWidth={'140px'}
            >
              <img
                src={src || undefined}
                alt='Payment icon'
                style={{ width: '24px' }}
              />
              <Typography variant='body1' sx={getTypographyStyles()}>
                {tooltipName}
              </Typography>
            </Stack>
          </Tooltip>
        )}
      </Box>
    </TableBodyCell>
  )
}

export default observer(PaymentCell)
